
import { ActionReducerMap } from '@ngrx/store';
import { formFormationReducer } from './form-formation/formFormation.reducer';
import { formInscriptionReducer } from './form-inscription/formInscription.reducer';
import { formEntrepriseReducer } from './form-entreprise/formEntreprise.reducer';
import { formFormateurReducer } from './form-formateur/formFormateur.reducer';
import { formArticleReducer } from './form-article/formArticle.reducer';

export const reducers: ActionReducerMap<any> = {
    formFormation: formFormationReducer,
    formInscription: formInscriptionReducer,
    formEntreprise: formEntrepriseReducer,
    formFormateur: formFormateurReducer,
    formArticle: formArticleReducer,
};
